<template>
  <div>
    <div
      :key="ingredient_class.id"
      v-for="ingredient_class in ingredientClasses"
    >
      <div class="ingredientsWrapper" v-if="ingredient_class.id === -1">
        <span
          v-for="(el, ingredient_index) in elements(ingredient_class)"
          :key="ingredient_index"
          class="ingredient"
        >
          <span v-if="ingredient_index !== 0">, </span>
          <span v-if="el.count >= 1">{{
            getTranslation($store, "Ingredient", "display_name", el.id, el.name)
          }}</span>
          <span v-else
            >{{ $t("ingredient.without", "without") }}
            {{
              getTranslation(
                $store,
                "Ingredient",
                "display_name",
                el.id,
                el.name
              )
            }}</span
          >
        </span>
        <span class="ingredientPrice" :class="{ invisible: noprices }">
          {{ ingredientClassPrice(ingredient_class) }}</span
        >
      </div>
      <div class="ingredientsWrapper" v-else>
        <ingredient-group-display
          :product="item"
          :ingredientgroup="ingredient_class"
        ></ingredient-group-display>
      </div>
    </div>
  </div>
</template>

<script>
import { getPopulatedIngredientGroups } from "@/utils/products";
import { hideZero, ingredientPrice, toPrintable } from "@/utils/pricing";
import { isEmpty } from "lodash";
import { getTranslation } from "@/utils/helpers";
import IngredientGroupDisplay from "../../../common/IngredientGroupDisplay";

export default {
  name: "IngredientsBlock",
  components: { IngredientGroupDisplay },
  computed: {
    ingredientClasses() {
      return getPopulatedIngredientGroups(this.item);
    }
  },
  methods: {
    getTranslation,
    hideZero,
    toPrintable,
    ingredientPrice,
    ingredientClassPrice(clazz) {
      if (isEmpty(clazz)) return "";
      let price = this.ingredientPrice(this.item, clazz.id);
      if (price !== 0.0) {
        let prefix = price > 0 ? "+" : "-";
        return `(${prefix}${toPrintable(price)})`;
      }
      return "";
    },
    ingredientClassInfo(clazz) {
      return this.ingredientClasses.find(ig => ig.id === clazz.id);
    },
    hasElements(clazz) {
      return this.elements(clazz).length > 0;
    },
    elements(clazz) {
      let rv = [];
      let ig = this.ingredientClasses.find(ig => ig.id === clazz.id);
      ig.ingredients.forEach(ing => {
        if (ing.count !== ing.default_count) {
          rv.push(ing);
        }
      });
      return rv;
    }
  },
  props: {
    ingredients: Object,
    item: Object,
    noprices: Boolean
  }
};
</script>

<style scoped>
.ingredient {
  font-family: var(--app_font-family_italic);
  letter-spacing: 0;
  color: #252525;
  font-size: 17px;
  margin-left: 0px;
}
.ingredientPrice {
  font-family: var(--app_font-family_italic);
  font-size: 17px;
}
</style>
